<div class="gah-main">
  <app-header *ngIf="showHeader"></app-header>
  <app-dynamic-breadcrumb
    [bgColor]="'black'"
    [fontSize]="'1.6rem'"
    [fontColor]="'#ced4da'"
    [lastLinkColor]="'#ced4da'"
    [symbol]="' > '"
  ></app-dynamic-breadcrumb>
  <app-notification></app-notification>
  <router-outlet></router-outlet>
  <app-footer *ngIf="showFooter"></app-footer>
</div>
